import React from 'react';
import { Crown, ArrowRight } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { goPro } from '../../lib/checkout';

const STAFF_HIDE = ['admin', 'teacher'];

/** Free (or trial) students only — Pro members and admin/teacher never see the gold button. */
export function useShowProCta() {
  const { user } = useAuth();
  if (!user) return false;
  const free = !user.subscription_status || user.subscription_status === 'free';
  return free && !STAFF_HIDE.includes(user.role);
}

/** Bottom-tab "Pro": raised gold disc → the Pro upgrade popup (or straight to /checkout when the popup is off). */
export function ProTab({ className }) {
  return (
    <button type="button" onClick={() => goPro()} data-testid="bottom-nav-pro"
      className={`${className} text-amber-700 hover:text-amber-800`} aria-label="Upgrade to Pro">
      <span className="pro-cta -mt-5 w-12 h-12 rounded-full ring-4 ring-white flex items-center justify-center">
        <Crown size={22} strokeWidth={2.4} className="relative z-[1]" />
      </span>
      <span className="font-extrabold tracking-wide">Pro</span>
    </button>
  );
}

/** Desktop sidebar button (sits above "Start Here"). */
export function SidebarProButton() {
  return (
    <button type="button" onClick={() => goPro()} data-testid="sidebar-pro-btn"
      className="pro-cta w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-extrabold mb-2 text-left whitespace-nowrap">
      <Crown size={18} strokeWidth={2.4} className="relative z-[1] shrink-0" />
      <span className="relative z-[1]">Upgrade to Pro</span>
      <ArrowRight size={16} strokeWidth={2.6} className="relative z-[1] ml-auto shrink-0" />
    </button>
  );
}
